module.exports = __webpack_public_path__ + "img/youtube.9c563f9d.svg";